const Visage = [ 
	
     { x: 266.4673789121966, y: 573.6565774565444 },
     { x: 44.98032355572558, y: 393.60230243026143 },
     { x: 412.7588069229122, y: 651.2988458163759 },
     { x: 191.9225307118657, y: 653.0461661406679 },
     { x: 526.2776907692438, y: 351.4872763862576 },
     { x: 129.85711098054824, y: 561.546250451725 },
     { x: 458.59092885352385, y: 366.88581658692414 },
     { x: 446.9148099009895, y: 315.4760712120367 },
     { x: 163.15049697096367, y: 318.42462058794456 },
     { x: 148.3207025444063, y: 607.706879557939 },
     { x: 83.554370107587, y: 355.06288587900116 },
     { x: 435.63950077227145, y: 318.4430313633574 },
     { x: 222.2082392357851, y: 77.25495795936796 },
     { x: 475.74935602853526, y: 144.51237322104907 },
     { x: 273.77145302041123, y: 74.31000798389906 },
     { x: 312.2862183820443, y: 556.4097362140576 },
     { x: 96.34728760854794, y: 209.64155865236725 },
     { x: 520.7952269000788, y: 354.84710416321303 },
     { x: 350.91248356625306, y: 574.9520284097395 },
     { x: 305.73743052607784, y: 605.9200325792494 },
     { x: 463.76297364190077, y: 336.99590869214427 },
     { x: 286.4139393870656, y: 587.1007179650632 },
     { x: 392.86172381022914, y: 673.4502569002169 },
     { x: 532.6419852658751, y: 349.42359980698393 },
     { x: 509.71112044025705, y: 239.12989967523026 },
     { x: 141.92072905836702, y: 116.83274801017248 },
     { x: 314.84754774365047, y: 470.0033201719292 },
     { x: 148.38246493947793, y: 601.7095867137313 },
     { x: 426.85095627655875, y: 375.8638601328815 },
     { x: 440.8898807099565, y: 363.7680839821811 },
     { x: 46.80793051055022, y: 387.31645204236065 },
     { x: 233.49500224343402, y: 564.9154274619656 },
     { x: 247.80256016858993, y: 396.48402502677055 },
     { x: 125.06016081153916, y: 148.22694654476481 },
     { x: 162.16605539420468, y: 625.8088551325274 },
     { x: 64.00979360470912, y: 443.51567057985454 },
     { x: 436.33999908621524, y: 360.9258938894572 },
     { x: 86.92711042567002, y: 332.5852778142614 },
     { x: 414.0323661533363, y: 363.94102583994027 },
     { x: 269.99252728595457, y: 583.6143567772642 },
     { x: 358.6321665368261, y: 587.4615678392979 },
     { x: 175.22009010905666, y: 356.0406727848109 },
     { x: 243.0459359668858, y: 532.1275863612163 },
     { x: 193.11830210299655, y: 658.1666497114198 },
     { x: 266.70107184314344, y: 68.70146986742876 },
     { x: 343.65879752211947, y: 415.5674496253332 },
     { x: 244.5977134778659, y: 73.73132195145554 },
     { x: 217.1640375611505, y: 334.58100982927874 },
     { x: 294.9199756974396, y: 606.527226386657 },
     { x: 271.68483709427, y: 600.886894950867 },
     { x: 100.12800892825597, y: 188.56091190433423 },
     { x: 304.4529749986742, y: 614.0770363383285 },
     { x: 445.67186763491253, y: 371.2998502989331 },
     { x: 239.66629963356945, y: 437.8396164400416 },
     { x: 556.4585075135085, y: 384.8987002887652 },
     { x: 467.46951879219836, y: 322.5878024604978 },
     { x: 287.55342787831376, y: 566.7661207368162 },
     { x: 391.1868572777511, y: 77.30916750929379 },
     { x: 290.9984930997507, y: 467.70250215520673 },
     { x: 144.86455967398751, y: 596.7930608107544 },
     { x: 271.51672218082007, y: 553.7339840781905 },
     { x: 335.5727460659142, y: 694.0070910206264 },
     { x: 172.736081213326, y: 373.49222824082517 },
     { x: 163.9940497026554, y: 323.50894227451624 },
     { x: 274.21451324136194, y: 356.28300195212915 },
     { x: 117.81330912841266, y: 379.70137671240536 },
     { x: 340.98551277532397, y: 381.01147220598676 },
     { x: 512.9965945992849, y: 218.2207387910435 },
     { x: 404.94481918364835, y: 659.5320273845477 },
     { x: 261.64522595099083, y: 579.656458416212 },
     { x: 342.05658192286467, y: 72.02499292974152 },
     { x: 258.91041767555333, y: 538.7088983280863 },
     { x: 221.5787589655773, y: 559.4060830019298 },
     { x: 332.69047270462477, y: 554.0401246362868 },
     { x: 466.1468495480507, y: 392.1608428387299 },
     { x: 455.10369405487296, y: 398.32823495756384 },
     { x: 234.50190058441, y: 548.360813491536 },
     { x: 381.7976125645153, y: 571.1290491546275 },
     { x: 133.3103943233262, y: 127.48853565727556 },
     { x: 84.5153390068822, y: 348.4603363021867 },
     { x: 479.83082739606795, y: 377.794149913514 },
     { x: 420.1097575130102, y: 377.5932578508568 },
     { x: 92.07267670895867, y: 235.52748261148636 },
     { x: 202.97384897843128, y: 668.0071037663326 },
     { x: 433.30195830755275, y: 94.36661139185235 },
     { x: 240.80124672923597, y: 551.8095547562646 },
     { x: 139.05158864517196, y: 394.91153472255746 },
     { x: 275.856893573398, y: 362.27539481964163 },
     { x: 239.08992230875464, y: 539.5321835398888 },
     { x: 182.91639284999331, y: 652.9445134274363 },
     { x: 516.7583010917115, y: 292.9248221485708 },
     { x: 234.45395391973767, y: 585.2034495686412 },
     { x: 140.85632772779076, y: 120.89283458818907 },
     { x: 362.4443288429137, y: 565.8459042699774 },
     { x: 325.7141661594505, y: 547.7305496084286 },
     { x: 305.1660525149528, y: 504.2313338625882 },
     { x: 494.8853944678468, y: 489.4147080300159 },
     { x: 184.70968295662996, y: 361.68372894808783 },
     { x: 347.4601765718472, y: 587.3896855033544 },
     { x: 102.3785730564647, y: 469.672325690457 },
     { x: 259.6718440981969, y: 533.7445292989976 },
     { x: 491.92120588268017, y: 495.9358090750785 },
     { x: 153.52391368623614, y: 370.2575211987622 },
     { x: 187.0655936022876, y: 321.3131310847905 },
     { x: 253.4886946176037, y: 602.503297874431 },
     { x: 306.4668708095614, y: 579.4273249745077 },
     { x: 154.75944916440585, y: 613.7646351772843 },
     { x: 517.8186614068386, y: 322.1531250362806 },
     { x: 190.36415352605968, y: 317.7408720224782 },
     { x: 231.99107534768996, y: 582.0234593008928 },
     { x: 268.99016169430183, y: 595.3935371010941 },
     { x: 421.7204010113665, y: 647.1821891774699 },
     { x: 486.62055641666313, y: 510.006832434063 },
     { x: 306.08463979059036, y: 584.1889396856182 },
     { x: 214.81651655580868, y: 674.2999188124847 },
     { x: 540.1865621605364, y: 435.9333611852885 },
     { x: 199.80370703638334, y: 665.8803468619593 },
     { x: 230.2622241857799, y: 567.8047675268501 },
     { x: 276.9791940511432, y: 577.6126347975271 },
     { x: 475.386643976267, y: 326.26005612914213 },
     { x: 536.2666898622961, y: 354.1316086490832 },
     { x: 116.79369169410779, y: 157.41346037201217 },
     { x: 95.6026821154282, y: 335.99652517029506 },
     { x: 63.55977276082791, y: 443.9035955964659 },
     { x: 284.7331708623129, y: 571.905071891208 },
     { x: 336.71922984126144, y: 600.6716424300809 },
     { x: 250.1784713870128, y: 541.8345188404649 },
     { x: 397.95287398654006, y: 397.7705255549904 },
     { x: 402.17271657558365, y: 370.14793117683547 },
     { x: 81.59530229349413, y: 468.3054561583073 },
     { x: 415.7390387417392, y: 331.6017162220992 },
     { x: 268.4474939021846, y: 70.14230254704589 },
     { x: 139.88560987050224, y: 328.6467907242673 },
     { x: 141.49762540882773, y: 373.5018428676695 },
     { x: 339.9163653471975, y: 598.039043160736 },
     { x: 210.17395403392055, y: 559.3022861187975 },
     { x: 153.50004533452386, y: 405.76314514828033 },
     { x: 220.38143636516756, y: 546.2500902937527 },
     { x: 148.1358961827095, y: 113.92067938433806 },
     { x: 419.2793158642574, y: 403.2798683887012 },
     { x: 554.4184466664484, y: 365.2767587180103 },
     { x: 332.03907362231746, y: 76.63459034568129 },
     { x: 514.5255467154687, y: 353.8791559506029 },
     { x: 268.90200345350263, y: 578.2236424871335 },
     { x: 343.2006526737816, y: 584.511589751777 },
     { x: 102.94954422354796, y: 482.1201953228237 },
     { x: 290.35341123551643, y: 591.0940459770288 },
     { x: 206.76041042775975, y: 373.35568076925034 },
     { x: 187.50187852145712, y: 87.18831451402914 },
     { x: 192.48369130109626, y: 377.93399032037826 },
     { x: 49.90489512730081, y: 423.27479807383503 },
     { x: 82.84959046399155, y: 340.24221685397436 },
     { x: 336.06581871382076, y: 549.9245970423357 },
     { x: 436.38682769464145, y: 321.49740787478385 },
     { x: 281.59815290651716, y: 539.2127151732002 },
     { x: 512.8072747778964, y: 262.0655583719868 },
     { x: 266.88567681069725, y: 535.045302877403 },
     { x: 364.1573163005514, y: 580.6724300170476 },
     { x: 280.3609559988262, y: 583.5805802208499 },
     { x: 473.51335616263464, y: 139.64404336249186 },
     { x: 515.5551523440507, y: 265.26079867581217 },
     { x: 117.88767784413581, y: 554.6955307210328 },
     { x: 488.3949090422006, y: 166.59848193781139 },
     { x: 478.22175280723286, y: 371.8587574145148 },
     { x: 47.06775501612862, y: 373.69660910392577 },
     { x: 247.74632595646867, y: 550.4096117667821 },
     { x: 431.1175219914949, y: 634.9341786875319 },
     { x: 239.67088793877858, y: 677.9682102922167 },
     { x: 210.90352492655103, y: 559.6777093181179 },
     { x: 308.3337695158519, y: 557.9005133518481 },
     { x: 306.42112881381894, y: 70.36059471960266 },
     { x: 288.1044390030994, y: 574.9866035299965 },
     { x: 470.2296030334467, y: 571.1458942849274 },
     { x: 182.97031909606247, y: 368.62209188684557 },
     { x: 345.9519415794788, y: 574.880272668884 },
     { x: 206.10863786773726, y: 326.79281909204377 },
     { x: 289.16924695438047, y: 600.1380904659428 },
     { x: 195.54886498355765, y: 361.8150480011256 },
     { x: 301.06605180811124, y: 606.4123492893467 },
     { x: 428.81478252128744, y: 384.58393878298523 },
     { x: 78.92854332768113, y: 471.0064710647987 },
     { x: 268.1216525301751, y: 486.5192179771152 },
     { x: 500.775719352622, y: 189.20284659429515 },
     { x: 327.23985761338827, y: 543.0692608837583 },
     { x: 518.948007745015, y: 259.4082926497019 },
     { x: 163.73993371154543, y: 397.211991620167 },
     { x: 445.1662630280415, y: 313.2900690832721 },
     { x: 346.4663888332916, y: 536.2694598593298 },
     { x: 263.4832889627713, y: 690.0110769251016 },
     { x: 332.72674619881917, y: 556.0126223377412 },
     { x: 373.8213220748206, y: 553.2677748781248 },
     { x: 92.3142417500226, y: 258.08713450403707 },
     { x: 518.0201516141129, y: 296.0179590395482 },
     { x: 491.1239580094335, y: 480.4858947098727 },
     { x: 285.7250967617243, y: 547.8583684792355 },
     { x: 157.75607656191974, y: 569.0342625601908 },
     { x: 467.39302637859623, y: 125.53364521726992 },
     { x: 288.87097707919355, y: 502.25651574315964 },
     { x: 364.2336921223609, y: 577.7650757655429 },
     { x: 130.54276118464853, y: 133.82082325503958 },
     { x: 137.45902052659474, y: 135.15574397401576 },
     { x: 170.96190452833363, y: 366.53665291178527 },
     { x: 510.67367147711946, y: 221.63456680700443 },
     { x: 80.38537394877262, y: 467.15134655825375 },
     { x: 306.73922996534077, y: 575.3069257193209 },
     { x: 199.97898570091007, y: 83.02253708507158 },
     { x: 311.37882273936646, y: 602.6310560044869 },
     { x: 280.09575825476287, y: 587.4798579067686 },
     { x: 332.257662845757, y: 588.1550432859179 },
     { x: 381.7079567145882, y: 549.0658915763572 },
     { x: 218.10764385548518, y: 618.7902332585307 },
     { x: 289.08042788202033, y: 496.63520431821445 },
     { x: 253.43982372690948, y: 546.7684129836656 },
     { x: 344.16918731107154, y: 536.0322375592109 },
     { x: 343.5800064387994, y: 574.3702735132935 },
     { x: 166.4254734519537, y: 95.6946790303464 },
     { x: 509.50481071216507, y: 205.2881659983859 },
     { x: 85.19749526104323, y: 284.61044754242533 },
     { x: 285.66276537106233, y: 537.5903833620721 },
     { x: 277.91348187864185, y: 557.0557701570274 },
     { x: 201.84375173338148, y: 312.81654562351173 },
     { x: 155.6833647596376, y: 379.64530267578056 },
     { x: 89.61527610955929, y: 276.57731157211913 },
     { x: 357.51671344570167, y: 445.4905724457615 },
     { x: 262.35405269163033, y: 591.5558822515392 },
     { x: 341.4265832136594, y: 402.97975158620756 },
     { x: 336.5454970591366, y: 554.808856352455 },
     { x: 338.8108654158523, y: 386.21190491533247 },
     { x: 62.29410028668256, y: 434.4151534909092 },
     { x: 274.45738202653604, y: 571.9742368531208 },
     { x: 341.7893099538025, y: 69.90888758818595 },
     { x: 291.59696822699465, y: 694.951117127495 },
     { x: 131.01204089825993, y: 581.1188255627313 },
     { x: 440.07546793304505, y: 622.5253503872548 },
     { x: 129.80448546127136, y: 132.07509681693074 },
     { x: 354.35576609953665, y: 550.7398928977868 },
     { x: 282.9297590565694, y: 544.4353660385846 },
     { x: 299.8464194521365, y: 574.1970274686262 },
     { x: 475.23207801189596, y: 539.1859329819075 },
     { x: 378.56031616763346, y: 105.73158911732048 },
     { x: 444.2022920228435, y: 400.0576256066704 },
     { x: 397.5951860276941, y: 333.56821546825324 },
     { x: 407.4928268221168, y: 324.3169936292797 },
     { x: 380.1804087668044, y: 382.63314427155257 },
     { x: 472.9772744651331, y: 549.561940072595 },
     { x: 337.39562802543065, y: 679.520022964981 },
     { x: 85.46573157247104, y: 266.5757302100127 },
     { x: 435.76747651257665, y: 623.6297144856846 },
     { x: 359.7715890762786, y: 460.3623238575772 },
     { x: 237.8868214936394, y: 553.9082455878154 },
     { x: 427.40803338286355, y: 396.3034949992361 },
     { x: 350.35428711896475, y: 555.5077201391757 },
     { x: 253.63063600491452, y: 578.4862550818945 },
     { x: 207.95696638755996, y: 560.3985413638992 },
     { x: 321.8494273521748, y: 546.3075021175285 },
     { x: 153.24497787928257, y: 327.5892261545342 },
     { x: 326.0403275349294, y: 550.3273086247202 },
     { x: 435.9027112894229, y: 390.8378423119485 },
     { x: 578.4454776513215, y: 380.9552882054736 },
     { x: 516.865663428321, y: 281.12429295271653 },
     { x: 219.86043878164682, y: 395.8842447452421 },
     { x: 238.63661955373212, y: 558.8971773047372 },
     { x: 263.2051036585788, y: 600.7747665854206 },
     { x: 300.59819849205, y: 547.3386996610002 },
     { x: 328.20022210148, y: 597.5044475116679 },
     { x: 469.72738250193714, y: 566.0412533381394 },
     { x: 544.0927127739517, y: 426.1500473309947 },
     { x: 173.78742820871713, y: 399.2257826771339 },
     { x: 345.6475707662303, y: 567.4140553625498 },
     { x: 227.03487368621637, y: 394.22966241042855 },
     { x: 348.0825347752216, y: 686.3411765444629 },
     { x: 317.75704727919214, y: 553.2026574434643 },
     { x: 137.18615062114262, y: 323.66973567558034 },
     { x: 283.69265883716326, y: 549.8509965004129 },
     { x: 253.9215095288844, y: 572.8524252808287 },
     { x: 449.87004049970386, y: 106.62787043393685 },
     { x: 219.99437880065622, y: 416.37647490479026 },
     { x: 281.9976632465242, y: 593.0505495625553 },
     { x: 190.8698146357645, y: 327.34830100973403 },
     { x: 349.91400025239744, y: 73.91128524884093 },
     { x: 198.75782346942145, y: 329.35951673488404 },
     { x: 537.5418105269933, y: 438.54096170853126 },
     { x: 559.7055940535485, y: 369.850642268703 },
     { x: 82.4979268058072, y: 468.68022882562207 },
     { x: 336.7314783331718, y: 484.0558482447011 },
     { x: 539.1891691391814, y: 432.4902816192978 },
     { x: 295.3059825489565, y: 508.45168345868046 },
     { x: 351.2408802136853, y: 589.2002948418931 },
     { x: 117.8699995356026, y: 151.8935291874072 },
     { x: 55.07590571846363, y: 423.7477665619812 },
     { x: 482.5586800812443, y: 528.0182428053537 },
     { x: 378.84988927917567, y: 553.0863248259049 },
     { x: 344.74915365102464, y: 402.81307028413767 },
     { x: 104.09410249570317, y: 470.14569215874127 },
     { x: 306.39688668462816, y: 586.3030155149526 },
     { x: 346.1553820900656, y: 534.6767801475837 },
     { x: 233.06570702483833, y: 551.9725508764444 },
     { x: 290.3305579659635, y: 605.6363334277353 },
     { x: 279.3698607118172, y: 697.0806284619722 },
     { x: 179.93313585769016, y: 649.9497830180358 },
     { x: 99.29316775278262, y: 190.37137034764697 },
     { x: 125.01707979690107, y: 378.06281305716914 },
     { x: 480.50290856535275, y: 129.44043131080184 },
     { x: 111.49557405640087, y: 510.693791301173 },
     { x: 229.47796014213253, y: 566.2304990117531 },
     { x: 445.8788551418248, y: 381.8731717179522 },
     { x: 181.21622539629172, y: 369.86857972532016 },
     { x: 481.5321251529917, y: 532.615350856103 },
     { x: 338.14650554475645, y: 547.3749355079741 },
     { x: 189.26268493870685, y: 369.67085989113076 },
     { x: 371.5815221938332, y: 580.0738868731673 },
     { x: 300.59266731173534, y: 605.0059285421552 },
     { x: 449.13313944388125, y: 602.1998970763779 },
     { x: 523.4962297457904, y: 353.1722562348122 },
     { x: 184.07341543450372, y: 652.0036543224064 },
     { x: 389.86276479278945, y: 382.06035191884837 },
     { x: 296.0698949306871, y: 570.9489598261298 },
     { x: 275.9423986511864, y: 597.8717833804045 },
     { x: 168.0677865181128, y: 637.9965811074997 },
     { x: 456.5435996103424, y: 364.43820711215744 },
     { x: 406.7476311580513, y: 87.42048937405292 },
     { x: 425.99515577822876, y: 317.6136252361328 },
     { x: 513.9670176633044, y: 267.086583545406 },
     { x: 459.57180469263636, y: 321.5937991695265 },
     { x: 281.94969843695196, y: 82.46943928427683 },
     { x: 549.179606561628, y: 411.0350064494238 },
     { x: 396.1428435908778, y: 372.17697091364045 },
     { x: 231.9472939994923, y: 572.5502709230298 },
     { x: 320.1110183921506, y: 554.4880268079517 },
     { x: 318.5654552090894, y: 702.3984994613047 },
     { x: 515.5676059093063, y: 293.7838320714042 },
     { x: 236.60864692602118, y: 546.2148108111669 },
     { x: 225.64800370736887, y: 691.1955838766798 },
     { x: 556.4677938733706, y: 378.23386028568507 },
     { x: 128.6306698920121, y: 391.00786745790646 },
     { x: 57.529431696247244, y: 351.9330545476477 },
     { x: 488.35188397760413, y: 513.7120192746736 },
     { x: 242.66644537263662, y: 583.1327000091436 },
     { x: 349.9546753776431, y: 570.359569647438 },
     { x: 426.8374389792639, y: 633.2491385045262 },
     { x: 430.2406703124842, y: 359.27584010735114 },
     { x: 372.6337579781076, y: 388.17192484526754 },
     { x: 177.9949245932683, y: 384.03186333285214 },
     { x: 342.9319921769125, y: 460.7349751876112 },
     { x: 219.89754258145499, y: 570.8294149751739 },
     { x: 72.59010178161908, y: 327.83082535344295 },
     { x: 80.88059438372318, y: 334.42463851100706 },
     { x: 331.1150428506585, y: 601.8565515735054 },
     { x: 531.9999976669679, y: 452.5795019597874 },
     { x: 497.2806085399758, y: 460.1699802376768 },
     { x: 215.69400207376927, y: 404.72274979778166 },
     { x: 279.36515889182647, y: 346.08789125190253 },
     { x: 211.5446177506433, y: 379.45298961643516 },
     { x: 102.6284890753618, y: 191.27318919041753 },
     { x: 316.7899295306267, y: 572.161650475492 },
     { x: 63.8107976501225, y: 437.2123049047845 },
     { x: 498.34772255442687, y: 469.9365291617356 },
     { x: 166.35027099240588, y: 392.93039127322635 },
     { x: 222.0603229262237, y: 676.0420563642755 },
     { x: 250.8397537562472, y: 692.4826150825575 },
     { x: 442.7748622798504, y: 107.82797376174481 },
     { x: 334.0380953085504, y: 587.8994231345022 },
     { x: 296.4932010246623, y: 606.7021040316024 },
     { x: 310.09699966933425, y: 557.06013232371 },
     { x: 242.08263297850363, y: 563.3878605069197 },
     { x: 297.2692675927077, y: 70.51965023321031 },
     { x: 319.5488027503742, y: 583.5134331910944 },
     { x: 365.2793124506188, y: 572.2984239218089 },
     { x: 60.76757366394704, y: 439.8361544980353 },
     { x: 201.12836633308964, y: 328.84558555364526 },
     { x: 98.78398450671455, y: 192.81060253153922 },
     { x: 42.22519104519687, y: 396.9660262974577 },
     { x: 314.13264425190016, y: 570.3366869460139 },
     { x: 283.20339007403686, y: 501.232432171536 },
     { x: 351.86893078885294, y: 550.0756006713987 },
     { x: 130.9409264979344, y: 367.1651663458803 },
     { x: 555.095230565948, y: 387.1752823503922 },
     { x: 492.4551115861355, y: 479.6895691413376 },
     { x: 269.97746589123045, y: 582.02063352989 },
     { x: 229.05250915799488, y: 552.4751669312398 },
     { x: 343.8150307310476, y: 472.8721061916454 },
     { x: 233.9728284984105, y: 590.951055898154 },
     { x: 186.56961321695115, y: 326.25314346807573 },
     { x: 492.6363164537142, y: 486.2501965440853 },
     { x: 344.7725113419045, y: 568.4423746466699 },
     { x: 448.0313618003901, y: 396.0903506162198 },
     { x: 420.73802342254805, y: 89.41457592798804 },
     { x: 197.77004371974974, y: 329.29096382178864 },
     { x: 535.9125836833098, y: 441.7880994756554 },
     { x: 362.0110915608095, y: 449.2154813965397 },
     { x: 402.7099545945058, y: 324.26988795448386 },
     { x: 458.21119249083176, y: 114.10141932186639 },
     { x: 502.03926228547203, y: 468.9078151632574 },
     { x: 404.4217771939787, y: 335.142952726251 },
     { x: 269.65690574732827, y: 554.825435746417 },
     { x: 226.68467352992715, y: 394.0219449779274 },
     { x: 477.47009112558106, y: 526.7762592533473 },
     { x: 45.5472993401187, y: 401.2637817941326 },
     { x: 455.2692960282636, y: 590.5528116119045 },
     { x: 320.47996738890794, y: 468.4635737598655 },
     { x: 438.31086986668043, y: 367.99389449166347 },
     { x: 260.2414912225909, y: 544.7955195859369 },
     { x: 284.5250506598665, y: 544.9447343415527 },
     { x: 203.26653226622804, y: 80.88916735936547 },
     { x: 94.29238255968092, y: 230.66721949770917 },
     { x: 258.4293420635307, y: 574.0789653683976 },
     { x: 318.90955244407206, y: 589.4950096272808 },
     { x: 384.0108763814193, y: 79.9710315332276 },
     { x: 144.02291702189817, y: 114.29227484635008 },
     { x: 484.36412646355825, y: 527.6718994988587 },
     { x: 460.3237424331764, y: 318.8184252701302 },
     { x: 72.30437030215761, y: 459.1311052823865 },
     { x: 481.70169150714685, y: 543.093574085767 },
     { x: 469.5990616611291, y: 371.0257361029032 },
     { x: 274.39783084974715, y: 541.1413451901645 },
     { x: 202.95118016018694, y: 620.9340855065448 },
     { x: 258.5443646391019, y: 600.8507715129938 },
     { x: 288.7250785294134, y: 567.2528011001627 },
     { x: 160.56042265671698, y: 384.29373669969664 },
     { x: 451.6830163811926, y: 358.59832866015887 },
     { x: 434.81539043937835, y: 368.91628256527036 },
     { x: 182.5382095000325, y: 369.6678867193054 },
     { x: 246.62083449706023, y: 454.415342732712 },
     { x: 118.9594666296864, y: 524.3641122468654 },
     { x: 218.48489747536792, y: 335.3501055519717 },
     { x: 40.79966342001858, y: 373.79968037151303 },
     { x: 290.6550492011248, y: 566.0211739026798 },
     { x: 134.54868830672777, y: 584.9967918182091 },
     { x: 351.4441344628223, y: 540.3463266969069 },
     { x: 43.726836748744674, y: 381.6415926908218 },
     { x: 86.84695864256665, y: 274.66693450113956 },
     { x: 121.8470057423449, y: 130.47349387298866 },
     { x: 208.73016153101207, y: 359.67815914375166 },
     { x: 319.4983717528619, y: 496.9452984969105 },
     { x: 270.94061082985434, y: 379.4308157797429 },
     { x: 468.41090279339505, y: 571.3571043541186 },
     { x: 519.735259474363, y: 354.8156495967474 },
     { x: 241.23759623150792, y: 681.5437952603302 },
     { x: 521.5726260119462, y: 353.85001364683256 },
     { x: 239.68353360400147, y: 688.2563411762989 },
     { x: 488.6442981545693, y: 501.57638149714603 },
     { x: 278.2030262749882, y: 598.4286083569045 },
     { x: 276.42482642052414, y: 580.7606181464098 },
     { x: 66.69733734705072, y: 440.6823941464055 },
     { x: 216.9923250377712, y: 77.64306361231692 },
     { x: 292.9063241244102, y: 566.5383867513867 },
     { x: 479.30113753183224, y: 386.41769218387793 },
     { x: 274.0222152891513, y: 591.998388555892 },
     { x: 278.35016041984693, y: 491.54408402433177 },
     { x: 319.68024203728584, y: 599.0835050124308 },
     { x: 441.8460278983959, y: 620.2145707137928 },
     { x: 326.88485026321746, y: 363.3269115665085 },
     { x: 408.86503697315976, y: 364.04486579190615 },
     { x: 288.5079742528209, y: 550.6200172897792 },
     { x: 216.3056799874358, y: 672.1129381301351 },
     { x: 131.53531836358985, y: 135.9310230548392 },
     { x: 335.0103006679522, y: 591.3461033575402 },
     { x: 332.4191646470537, y: 585.6425378136435 },
     { x: 404.6574730413094, y: 327.702783898704 },
     { x: 468.022307156561, y: 332.59552963209137 },
     { x: 104.21189193168841, y: 481.9261259885569 },
     { x: 513.8560011029314, y: 301.8941952035377 },
     { x: 292.56114491908136, y: 598.9330663879695 },
     { x: 479.7063671553468, y: 525.8520403711703 },
     { x: 422.0967067362101, y: 642.2085184302043 },
     { x: 147.37440504139104, y: 321.26628208677425 },
     { x: 268.176333212133, y: 589.7958606759106 },
     { x: 414.4716831554865, y: 378.57954471673764 },
     { x: 126.99668408698675, y: 136.0259029842744 },
     { x: 379.0099225813629, y: 565.760147841299 },
     { x: 512.1426328387774, y: 316.0613544665008 },
     { x: 387.34589954495823, y: 77.97792761377556 },
     { x: 95.14288181649094, y: 335.57547371490705 },
     { x: 444.7516896434117, y: 395.8869146727686 },
     { x: 369.60164094299853, y: 583.0595529098501 },
     { x: 281.62425817555436, y: 556.4391428190039 },
     { x: 513.6400022835239, y: 251.99406889802054 },
     { x: 41.119213207774365, y: 386.70819057331875 },
     { x: 134.21988247926137, y: 368.08908562798575 },
     { x: 287.81414410062393, y: 68.81269501424995 },
     { x: 280.9403770800144, y: 556.1095156411576 },
     { x: 422.8080206185816, y: 380.1170317407426 },
     { x: 132.4833036943981, y: 136.6842853810878 },
     { x: 249.7636475559913, y: 580.2268512455468 },
     { x: 163.0490982120895, y: 364.97026432867267 },
     { x: 408.6355407886387, y: 80.92965545576564 },
     { x: 69.489806113275, y: 357.75226895613565 },
     { x: 198.02947433540936, y: 83.73842719949548 },
     { x: 475.9107622122592, y: 374.5331912272248 },
     { x: 491.96739166231396, y: 490.9479193784447 },
     { x: 390.7648701256705, y: 79.17591705461402 },
     { x: 357.73487066815466, y: 447.91839907723573 },
     { x: 312.36367881574546, y: 590.2333865608547 },
     { x: 166.44871355850262, y: 111.2101517535773 },
     { x: 172.76815306439133, y: 376.8584300873004 },
     { x: 325.4485303304768, y: 567.5118074829912 },
     { x: 247.9641081067218, y: 535.967339301635 },
     { x: 376.3428845502685, y: 546.2163301038097 },
     { x: 88.43283376483342, y: 210.47741730405497 },
     { x: 130.00891967617463, y: 381.18304666579786 },
     { x: 151.843881078193, y: 619.3311351398908 },
     { x: 321.94373157789477, y: 561.4867579596785 },
     { x: 233.62156276878264, y: 552.3638944046222 },
     { x: 386.8602902125622, y: 572.1111422684723 },
     { x: 275.5736555945912, y: 555.4236631663991 },
     { x: 415.8993003275077, y: 317.82994400655053 },
     { x: 360.51391120914315, y: 440.8492470363638 },
     { x: 339.91869230881105, y: 406.2242690166618 },
     { x: 89.36720355308196, y: 317.1394272024652 },
     { x: 234.70196663934766, y: 558.2584985256717 },
     { x: 480.76250317651886, y: 141.14526949980703 },
     { x: 222.07517383781348, y: 574.4885662792681 },
     { x: 415.43708916637956, y: 348.7216265493422 },
     { x: 471.76204787537387, y: 569.5906594467489 },
     { x: 548.3598969280771, y: 422.7859335080739 },
     { x: 305.08779633117524, y: 578.6162091876494 },
     { x: 403.70446257993035, y: 329.8882401732627 },
     { x: 284.688791465485, y: 592.5803393211468 },
     { x: 160.21180316075578, y: 317.6247798381198 },
     { x: 240.49461016722535, y: 423.96093445882116 },
     { x: 434.7885981065511, y: 388.1585373281158 },
     { x: 330.1515125128317, y: 599.9940081519693 },
     { x: 120.41447958447924, y: 149.7377663317169 },
     { x: 495.36290420619235, y: 180.9424727801189 },
     { x: 376.7065084548549, y: 379.6544798463651 },
     { x: 333.2612155737481, y: 544.5487940789708 },
     { x: 214.96656231872475, y: 387.68511498691515 },
     { x: 554.3752690418191, y: 402.3067908080457 },
     { x: 377.1674172814737, y: 559.0462323442866 },
     { x: 143.34261120588252, y: 597.9951992871272 },
     { x: 133.00606332161573, y: 560.7559750559096 },
     { x: 116.34830653892196, y: 373.41146634602893 },
     { x: 320.5744222923671, y: 584.4097263700128 },
     { x: 444.372112398979, y: 107.47821470816064 },
     { x: 277.1116799986113, y: 546.7153982750046 },
     { x: 444.55932138247016, y: 391.63485808540827 },
     { x: 320.9956171862061, y: 586.2258450862735 },
     { x: 494.4704139955502, y: 476.90102199655155 },
     { x: 198.87787381779884, y: 371.49222513107225 },
     { x: 295.37921506113224, y: 593.9527204165 },
     { x: 327.8843513999528, y: 581.1584587857349 },
     { x: 207.15074302648452, y: 562.6988092962488 },
     { x: 463.085332955604, y: 568.0107809224912 },
     { x: 280.0178811676643, y: 73.12737748761145 },
     { x: 171.78501287720636, y: 376.40700759590044 },
     { x: 485.0912675552167, y: 528.7547505385091 },
     { x: 265.55086637450387, y: 586.8160324364545 },
     { x: 212.07978062373303, y: 569.3219555524634 },
     { x: 124.54711469913931, y: 385.90809918716843 },
     { x: 144.9482986138696, y: 626.4960575322033 },
     { x: 104.51726587438746, y: 479.6541678836482 },
     { x: 227.1737008645047, y: 570.0029240641246 },
     { x: 358.29831346569523, y: 567.1704327617518 },
     { x: 99.23394354184813, y: 183.52881001595154 },
     { x: 495.18599433521206, y: 170.26918897926925 },
     { x: 345.6197770503462, y: 421.853665687435 },
     { x: 301.954351133261, y: 582.9890850679866 },
     { x: 273.1929502946352, y: 570.2688520204639 },
     { x: 224.9960774958302, y: 397.51529170149996 },
     { x: 245.17047262963138, y: 596.453136140419 },
     { x: 332.42431190966164, y: 424.45596007526166 },
     { x: 534.0242203175443, y: 354.04162781004493 },
     { x: 145.4846272041212, y: 362.8282334368079 },
     { x: 485.1044684952036, y: 527.2694735259323 },
     { x: 407.98920938478483, y: 322.07913762577465 },
     { x: 449.22596221270413, y: 370.61915984924156 },
     { x: 275.2864695500965, y: 572.7763228375627 },
     { x: 145.78581305281844, y: 389.520057267837 },
     { x: 200.57249647831563, y: 665.4869713913772 },
     { x: 91.21038269676717, y: 247.19297845836547 },
     { x: 148.7231509697054, y: 323.8617531926832 },
     { x: 285.20005008671694, y: 499.44870097252476 },
     { x: 287.86794159802184, y: 68.3280861647822 },
     { x: 262.04791913314136, y: 457.9366714859953 },
     { x: 291.12847762757946, y: 497.25252293778163 },
     { x: 157.5575661384808, y: 613.7542938961184 },
     { x: 152.36255406024142, y: 111.72865015534013 },
     { x: 221.3547952711989, y: 398.80058110289235 },
     { x: 395.98498412934856, y: 557.9745762927455 },
     { x: 221.12781311201798, y: 571.6164044003675 },
     { x: 310.1943804003357, y: 70.28747989336905 },
     { x: 144.6298321781766, y: 364.43438148488735 },
     { x: 468.2313772414893, y: 580.6044169041944 },
     { x: 391.2949745100526, y: 74.8232118879119 },
     { x: 274.53798509100153, y: 592.4626782466914 },
     { x: 281.23785736441226, y: 559.9314906307616 },
     { x: 129.3146998451577, y: 387.61616189161805 },
     { x: 414.97491138152174, y: 651.4976292371203 },
     { x: 533.1440046056534, y: 444.100624361246 },
     { x: 302.67618365691635, y: 694.2348211626945 },
     { x: 277.6532052946816, y: 572.9918939349806 },
     { x: 337.6350792444689, y: 564.3077246501596 },
     { x: 215.01391344931443, y: 552.6906896330954 },
     { x: 355.44326194883394, y: 528.7591727384239 },
     { x: 303.34621446305414, y: 603.4430075005068 },
     { x: 185.3482808887722, y: 375.3299360655548 },
     { x: 232.97467273185583, y: 559.4216939662549 },
     { x: 59.44080574043686, y: 439.0104624322103 },
     { x: 514.252692833462, y: 335.5214139436792 },
     { x: 228.414658599073, y: 553.7284537633726 },
     { x: 262.8068848216079, y: 589.6842259430142 },
     { x: 125.5213485314329, y: 386.42569149352056 },
     { x: 259.99157745565316, y: 541.1617363750082 },
     { x: 223.9306093681094, y: 385.28272583036227 },
     { x: 432.55157413589825, y: 401.92386183632345 },
     { x: 297.26753119687265, y: 582.2659363352766 },
     { x: 324.38149251949835, y: 544.344031412462 },
     { x: 281.77452950356616, y: 341.0570633838083 },
     { x: 245.99967483267693, y: 432.00795934265665 },
     { x: 365.818348165918, y: 75.90069552165588 },
     { x: 261.3479161409089, y: 568.924809909238 },
     { x: 105.93879206459363, y: 175.85743649454437 },
     { x: 294.905876701784, y: 81.74388649444056 },
     { x: 420.2381950378219, y: 361.4187941246057 },
     { x: 535.4726978331669, y: 350.1063077239801 },
     { x: 508.91357094684776, y: 221.51660235760045 },
     { x: 248.47600941603093, y: 574.287133774995 },
     { x: 337.4233393314223, y: 554.0144449510794 },
     { x: 162.1258917920477, y: 378.09117490061567 },
     { x: 234.265951693759, y: 589.919920077647 },
     { x: 236.32394916222182, y: 515.5081875365406 },
     { x: 212.29178743084762, y: 336.9156542549815 },
     { x: 474.58118932848043, y: 131.8245862693532 },
     { x: 260.37430840687165, y: 689.7732380711954 },
     { x: 306.9571585365874, y: 542.6253564825429 },
     { x: 145.72366100107092, y: 598.2239118747633 },
     { x: 209.38163633964268, y: 571.312496165844 },
     { x: 287.9985140003391, y: 541.17480331968 },
     { x: 241.42438750900814, y: 551.8705971738539 },
     { x: 418.2967121347323, y: 86.27124491636464 },
     { x: 409.2577857469215, y: 652.9158083207034 },
     { x: 154.09079817699035, y: 316.0723395068745 },
     { x: 215.13840248632064, y: 383.9099425297961 },
     { x: 113.867967624238, y: 521.5080452437593 },
     { x: 79.48039478129643, y: 458.4282697710075 },
     { x: 366.1689800618879, y: 437.6582906823928 },
     { x: 348.7964063650519, y: 616.2846984959707 },
     { x: 164.15387337174306, y: 380.69241307533264 },
     { x: 228.62053666456572, y: 576.5993298637773 },
     { x: 174.91445306247502, y: 641.808566368309 },
     { x: 280.2165684711436, y: 345.2812209201081 },
     { x: 376.0071786940241, y: 574.0035212000163 },
     { x: 433.9330063575163, y: 627.3646209607128 },
     { x: 313.9535064192986, y: 72.0417706703937 },
     { x: 293.80276140942834, y: 586.5138477833632 },
     { x: 107.00345900486762, y: 399.3833881736556 },
     { x: 454.70347981018887, y: 323.63963870556586 },
     { x: 509.42476216708695, y: 233.30291196236496 },
     { x: 458.5313892097801, y: 314.95796036505885 },
     { x: 211.76781167155534, y: 79.00456834951135 },
     { x: 506.17794914320166, y: 208.1414350777653 },
     { x: 549.8006461859917, y: 366.32741358608007 },
     { x: 381.16040772365136, y: 556.5331875876374 },
     { x: 555.4911117898733, y: 402.85797109193567 },
     { x: 357.352514788717, y: 72.18841250304246 },
     { x: 465.1825067066409, y: 593.7612823884716 },
     { x: 45.63749827906213, y: 417.9429196774867 },
     { x: 428.67966069386006, y: 631.1494016400417 },
     { x: 93.22504949275199, y: 227.8101704346049 },
     { x: 327.1687239830978, y: 584.8268642880125 },
     { x: 382.5737624514999, y: 672.942884705858 },
     { x: 417.01479390300557, y: 86.6237212567874 },
     { x: 299.534702854872, y: 604.9214884229186 },
     { x: 82.46466243042258, y: 296.7559989702076 },
     { x: 469.05749924702815, y: 570.803901478398 },
     { x: 548.416404549676, y: 411.46273329110153 },
     { x: 207.19444293122618, y: 396.17477924025235 },
     { x: 137.31914036610482, y: 117.87886786286523 },
     { x: 524.6282841980736, y: 353.87914711887095 },
     { x: 264.1114631804165, y: 390.4071063423225 },
     { x: 461.64124126547125, y: 575.9944975353112 },
     { x: 100.14916574554309, y: 475.95458168595655 },
     { x: 82.87964294267692, y: 345.9542708444023 },
     { x: 162.91742471684995, y: 356.6414013387839 },
     { x: 474.1294734774174, y: 382.2910915540432 },
     { x: 391.9330080416069, y: 379.4494405524712 },
     { x: 272.1940119622495, y: 606.0658835384687 },
     { x: 297.4894725940474, y: 569.3490862314719 },
     { x: 309.88205293583036, y: 580.0385019259352 },
     { x: 202.2754239662574, y: 401.18549468754253 },
     { x: 238.93585389228474, y: 552.7938636842366 },
     { x: 301.05273034935334, y: 464.50694519553815 },
     { x: 278.51979496204035, y: 551.1360032991892 },
     { x: 447.99843026762403, y: 316.4633452019352 },
     { x: 136.55298774439055, y: 129.56062825213027 },
     { x: 352.8463438155118, y: 667.2322878801184 },
     { x: 329.3089923396144, y: 563.4281225790013 },
     { x: 324.29614078905576, y: 549.4059984415384 },
     { x: 81.30275630875221, y: 465.6418015315667 },
     { x: 265.90644446526466, y: 551.9620254895567 },
     { x: 314.36663324232194, y: 462.4325657575831 },
     { x: 160.69704564150487, y: 316.17645086557 },
     { x: 357.09604684502096, y: 70.87159566619326 },
     { x: 422.0809897820798, y: 649.4120102226937 },
     { x: 238.3583422263273, y: 72.0816300724581 },
     { x: 235.9568170909422, y: 684.3333620427104 },
     { x: 264.2999938761357, y: 462.4978710074971 },
     { x: 154.50134419162956, y: 106.24723448908003 },
     { x: 295.50969179302064, y: 503.801480761807 },
     { x: 193.07360101369073, y: 319.74994058417707 },
     { x: 189.78576774745414, y: 654.1202216704935 },
     { x: 464.26684607661275, y: 111.6502691182958 },
     { x: 514.0351978123443, y: 308.095802788821 },
     { x: 139.53612434063965, y: 320.3225047128901 },
     { x: 310.9688580660279, y: 471.6815706214519 },
     { x: 301.27108172700207, y: 590.8210596505985 },
     { x: 459.75109980663825, y: 324.16263024493975 },
     { x: 173.98056843293847, y: 405.7153956588838 },
     { x: 271.54708817583304, y: 543.6069480460568 },
     { x: 373.45735436020016, y: 684.736672936609 },
     { x: 258.4670622793666, y: 473.3561677691981 },
     { x: 148.08397004811783, y: 588.6399199330685 },
     { x: 269.2582375283262, y: 547.0868893320558 },
     { x: 465.890280760659, y: 123.76145044192812 },
     { x: 43.88692702928941, y: 408.033412702585 },
     { x: 316.1936570581292, y: 501.88793804529774 },
     { x: 485.62002964448385, y: 526.1113326149754 },
     { x: 42.04833443432759, y: 377.9679053636667 },
     { x: 155.3633812469997, y: 368.72393282045425 },
     { x: 156.22862088851892, y: 382.8615124097247 },
     { x: 317.96269601056304, y: 605.1311028547672 },
     { x: 243.3721992752832, y: 586.0852647580163 },
     { x: 176.44589583319427, y: 390.7012439901193 },
     { x: 253.62236500340958, y: 576.4343851804343 },
     { x: 90.46572407420912, y: 237.98180613447298 },
     { x: 345.7248501507481, y: 543.6280522399497 },
     { x: 405.01129287111513, y: 368.67000310221454 },
     { x: 453.97027374489335, y: 364.76669434267257 },
     { x: 399.2347742900724, y: 575.4244733026137 },
     { x: 407.8114265506203, y: 85.43589112155588 },
     { x: 306.40047541036057, y: 571.9106196431634 },
     { x: 353.9933902338233, y: 590.9556830625576 },
     { x: 440.2345048578824, y: 364.5120698338385 },
     { x: 226.19229134104586, y: 570.4676024928411 },
     { x: 129.73733522176042, y: 374.1031837794627 },
     { x: 87.97420457317128, y: 281.60389375357454 },
     { x: 200.2907859033554, y: 369.7450085821485 },
     { x: 253.87637125625676, y: 472.85269979925675 },
     { x: 80.01629296443078, y: 460.65292478504904 },
     { x: 153.12442486263166, y: 378.43054591391234 },
     { x: 289.4163590713927, y: 691.6652897089815 },
     { x: 120.31335549072357, y: 623.9810252753136 },
     { x: 239.61364504291188, y: 77.51497876141103 },
     { x: 294.281241072525, y: 503.8990596513644 },
     { x: 233.09230945288806, y: 548.6353934115439 },
     { x: 88.05344903691163, y: 460.6023114288556 },
     { x: 487.9197988143427, y: 498.9970402663812 },
     { x: 195.54690194013068, y: 659.0523903486012 },
     { x: 361.3189451266883, y: 552.1979939302859 },
     { x: 89.71122821863142, y: 465.9001243199703 },
     { x: 110.84122200276707, y: 468.5391745286443 },
     { x: 120.0452382618059, y: 150.80429615181365 },
     { x: 142.16035968580044, y: 599.6496367566004 },
     { x: 311.99035771098056, y: 543.9649749370282 },
     { x: 86.85900958557623, y: 465.91035460508795 },
     { x: 480.9023410837063, y: 519.1098701752403 },
     { x: 534.714328161349, y: 351.13477909839855 },
     { x: 268.7852680900559, y: 584.7937795718674 },
     { x: 297.500351108357, y: 561.8371356352018 },
     { x: 357.48579328736844, y: 626.0893469399114 },
     { x: 148.66047366147708, y: 108.81963571370255 },
     { x: 504.06129679324437, y: 196.44033293102729 },
     { x: 39.97064916283551, y: 384.5639809152678 },
     { x: 385.7471963080373, y: 378.82590823832885 },
     { x: 222.86536910210035, y: 676.9152658440787 },
     { x: 274.17855648890355, y: 573.0554768811529 },
     { x: 157.6040568658659, y: 317.8129758369981 },
     { x: 469.7445326290402, y: 365.11751748254414 },
     { x: 285.5488119907342, y: 563.5671122758629 },
     { x: 421.74157433678266, y: 86.01681715893751 },
     { x: 185.75161953855053, y: 361.69021329768117 },
     { x: 111.22165438822606, y: 503.19285684899654 },
     { x: 261.9690787188269, y: 593.1340134892499 },
     { x: 405.6721670834005, y: 85.64573419120391 },
     { x: 303.35015223515654, y: 588.9041559214706 },
     { x: 242.72978349970273, y: 586.836030889125 },
     { x: 313.31560550429566, y: 553.2770127235754 },
     { x: 393.4919482914993, y: 562.5470395854601 },
     { x: 382.13999602898633, y: 335.91337437370237 },
     { x: 64.7510329446142, y: 362.35589209751276 },
     { x: 106.65255159443288, y: 526.7972545169232 },
     { x: 84.75282466298098, y: 267.6329839099751 },
     { x: 523.627563416509, y: 451.39706481678957 },
     { x: 505.64277962986483, y: 211.82585614744468 },
     { x: 441.88820434406375, y: 356.7630184556231 },
     { x: 193.83797149101068, y: 330.4453954294463 },
     { x: 362.78878140647413, y: 76.99833982209923 },
     { x: 100.48569165820683, y: 206.03668967725855 },
     { x: 512.896210579995, y: 279.04744892273794 },
     { x: 352.07190056599285, y: 549.0798918789504 },
     { x: 556.7548126696616, y: 380.66241225303264 },
     { x: 159.2431514127427, y: 399.28766487238 },
     { x: 434.1052464162849, y: 370.2171311717948 },
     { x: 369.16797834862496, y: 435.8064549127694 },
     { x: 215.4316131237455, y: 674.0808609461454 },
     { x: 357.1161340303655, y: 575.638657316727 },
     { x: 323.6594505596872, y: 545.0000711137494 },
     { x: 43.12847710923316, y: 369.30806839026127 },
     { x: 347.5791374984085, y: 531.6880652996502 },
     { x: 429.0752374218542, y: 383.6650495530157 },


 ]

export { Visage }


// WEBPACK FOOTER //
// ./src/components/particles/js/Visage.js